import axios from 'axios';
import { BACKEND_URL } from '../utils/constants';

const API_URL = `${BACKEND_URL}/api/admin`;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminService = {
  getDashboard: () => api.get('/dashboard'),
  getUsers: (params = '') => api.get(`/users?${params}`),
  getUser: (id) => api.get(`/users/${id}`),
  updateUserStatus: (id, status) => api.patch(`/users/${id}/status`, { status }),
  updateUserProfile: (id, data) => api.put(`/users/${id}/profile`, data),
  getWallets: (params = '') => api.get(`/wallets?${params}`),
  getWalletDetail: (userId) => api.get(`/wallets/${userId}`),
  adjustWallet: (userId, data) => api.post(`/wallets/${userId}/adjust`, data),
  uploadPhoto: (userId, formData) => api.post(`/users/${userId}/photos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletePhoto: (userId, photoId) => api.delete(`/users/${userId}/photos/${photoId}`),
  setPrimaryPhoto: (userId, photoId) => api.post(`/users/${userId}/photos/${photoId}/primary`),
  approvePhoto: (userId, photoId) => api.post(`/users/${userId}/photos/${photoId}/approve`),
  rejectPhoto: (userId, photoId) => api.post(`/users/${userId}/photos/${photoId}/reject`),
};
